import { render, staticRenderFns } from "./notification-toolbar.vue?vue&type=template&id=d04edfe6&"
import script from "./notification-toolbar.vue?vue&type=script&lang=js&"
export * from "./notification-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports